import axios from 'axios'
import Vue from 'vue'
import router from './route.js'
import store from './store.js'
import {url,loginApi,api} from './config'
import {downFile} from './util'
import {Loading} from 'element-ui';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=utf-8';

axios.defaults.baseURL = api.httpUrl                 
//获取个人信息方面删除更新的操作
let operationREN = ""
//Loding  开启lODING
let loadingInstance = {}

//axios 请求拦截器
axios.interceptors.request.use((config) => {
      let BrenPlivateMessage = localStorage.getItem("BrenPlivateMessage")
          if(!!BrenPlivateMessage){
             operationREN = JSON.parse(BrenPlivateMessage).operateUserVo.name
             store.commit({
                type:"setOperator",
                operator:operationREN
             })
          }
      if(config.url!=loginApi.LOGIN){
         if(!localStorage.getItem("YunWeiTikenBRJ")){

            console.log("jiegu",config.url)
            router.replace({path:"/", query:{}})      //Token不存在返回登录页面
         }else{
            loadingInstance = Loading.service({fullscreen: true,spinner:"el-icon-loading"});  
            config.headers["Authorization"] = localStorage.getItem("YunWeiTikenBRJ") //配置请求Token 
         } 
      }
      return config;
    },(err) => {
      return Promise.reject(err);
    }
);

//axios 相应拦截器
axios.interceptors.response.use((config) => {
      store.commit({type: "setloginStade", loginStade:false})
      if(config.config.url == loginApi.LOGIN){                         
          localStorage.setItem("YunWeiTikenBRJ",config.data.data)    //登录页面配置本地Token
          store.commit({type: "setloginStade", loginStade:false})
      }else{
         loadingInstance.close();
         if(config.status==200){
            if(config.data.code!=1){
                //数据请求失败
                if(config.data.exceptionCode=="40001"){
                    Vue.prototype.$message.warning("系统繁忙"); 
                    return 
                    //Token过期重新登录
                }else if(config.data.exceptionCode=="20015" || config.data.exceptionCode=="20011"){
                    setTimeout(res=>{
                        router.replace({path:"/", query:{}})
                        localStorage.removeItem("YunWeiTikenBRJ")
                        localStorage.removeItem("BrenPlivateMessage")
                        localStorage.removeItem("menuBtnVav")
                    },1000)
                }else{
                    if(!!config.data.exceptionMsg){
                        Vue.prototype.$message.warning(config.data.exceptionMsg);
                    }
                }
            }
         }else{
            Vue.prototype.$message.warning(config.statusText);  
         }
      }
      return config
    },(e) => { 
      loadingInstance.close();
      store.commit({type: "setloginStade", loginStade:false})       //登录页失败时候关闭登录页的动画
    }
);

//登录的特殊方法
export function login(url,parms,callback){
    axios.post(url,parms,{}).then(function (res){
        localStorage.setItem("YunWeiTikenBRJ",res.data.data)
        if(res.data.code==1){
          callback(res)     
        }else{
          Vue.prototype.$message.warning(res.data.exceptionMsg);  
        }
    })
}

//post 请求方式
export function postFun(url,parms,callback){
    return new Promise((resolve, reject) => {
        axios.post(url,parms).then(function (res){
           callback(res.data)  
        }).catch(function (err) {
        });  
    })
}

//PUT 请求方式
export function putFun(url,parms,callback){
    return new Promise((resolve, reject) => {
        axios.put(url,parms).then(function (res){
           callback(res.data)    
        }).catch(function (err) {
        });  
    })
}

//get 请求方式
export function getFun(url,parms,callback){
    return new Promise((resolve, reject) => {
        let parm = ''
        for (let it in parms) {
            parm += "&" + it + '=' + parms[it]
        }
        let newUrl = url+'?'+parm.substr(1)
        axios.get(newUrl).then(function (res){
           callback(res.data)
        }).catch(function (err) {
          
        });  
    })
}

//DELET 请求方式
export function deleteFun(url,parms,callback){
    return new Promise((resolve, reject) => {
        let parm = ''
        for (let it in parms) {
            parm += "&" + it + '=' + parms[it]
        }
        let newUrl = url+'?'+parm.substr(1)
        axios.delete(newUrl).then(function (res){
           callback(res.data)
        }).catch(function (err) {
           
        });  
    })
}

//获取图片的的地址链接
export function httpImg(ev,callback){
    let parms = {
        bucketName: api.bucketName,
        objectNames: ev.split(",")    //数组格式['789456-12','963258-56']
    }
    postFun(url.SHOWIMGMORE,parms,res=>{
        callback(res.data)
    })
}

//导出文件
export function exportFun(url,param,textName){
    axios({
        method:'post',
        headers: { 'Authorization':localStorage.getItem('YunWeiTikenBRJ') },
        responseType: 'arraybuffer',
        url:url,
        data:param
      }).then(res=>{
        if(!!res && res.status == 200){
            downFile(res.data,textName,'xlsx')
        }else if(!!res){
           Vue.prototype.$message.warning(res.message)
        }
      }).catch(err=>{
           Vue.prototype.$message.warning(err.message);
      })
}


